import React, { useEffect, useState } from 'react';
import { getSettingsCategories, getTemplatesSettings } from 'api/admin/endpoints/mailing';
import { Modal, openNotification, Loader, Tabs } from 'tt-ui-lib/core';
import { SocialMediaTab, SectionsTab, PhotoTab } from './Tabs';

const Manage = ({ open, setOpen }) => {
  const tabs = [
    { id: 'social', name: 'Social media', disabled: false },
    { id: 'sections', name: 'Sections', disabled: false },
    { id: 'photo', name: 'Photo', disabled: false },
  ];

  const [selectedTab, setSelectedTab] = useState(0);
  const [manageData, setManageData] = useState(null);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(false);

  const getSettingsData = async () => {
    setLoading(true);

    getTemplatesSettings()
      .then((res) => {
        setManageData(res.data?.data?.settings || null);

        getSettingsCategories()
          .then((resCategories) => {
            setCategories(resCategories.data?.data?.categories || []);
          })
          .catch((err) => {
            openNotification({
              type: 'error',
              message: 'Failed to get settings categories',
            });
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch((err) => {
        openNotification({
          type: 'error',
          message: 'Failed to get settings data',
        });
        setLoading(false);
      });
  };

  const onUpdate = () => {
    setUpdate(true);
  };

  useEffect(() => {
    if (update) {
      getSettingsData();
      setUpdate(false);
    }
  }, [update]);

  useEffect(() => {
    if (open) {
      getSettingsData();
    }
  }, [open]);

  const renderContent = () => {
    switch (selectedTab) {
      case 0:
        return <SocialMediaTab data={manageData} onUpdate={onUpdate} categories={categories} />;
      case 1:
        return <SectionsTab data={manageData} onUpdate={onUpdate} categories={categories} />;
      case 2:
        return <PhotoTab data={manageData} onUpdate={onUpdate} categories={categories} />;
      default:
        return null;
    }
  };

  return (
    <div>
      <Modal open={open} onClose={() => setOpen(false)} title="Manage Templates">
        <Tabs tabs={tabs} selectedTab={selectedTab} onChangeTab={setSelectedTab} />
        {loading ? (
          <div
            style={{
              width: '100%',
              height: 200,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Loader />
          </div>
        ) : (
          renderContent()
        )}
      </Modal>
    </div>
  );
};

export default Manage;
